// src/components/ExpenseCategoryAddEditModal.js
import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import ExpenseCategoryServices from "../../../Services/QRCodeServices/ExpenseCategoryServices/ExpenseCategoryServices";

const ExpenseCategoryAddEditModal = ({
  isOpen,
  toggle,
  isEdit,
  selectedCategory,
  onSuccess,
}) => {
  // Validation schema using Yup
  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string(),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      title: selectedCategory?.title || "",
      description: selectedCategory?.description || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true, // Reinitialize form when selectedCategory changes

    onSubmit: async (values) => {
      try {
        const payload = {
          title: values.title,
          description: values.description,
        };

        if (isEdit) {
          payload.id = selectedCategory.id;
          await ExpenseCategoryServices.update(selectedCategory.id, payload); // Hypothetical update method
          toast.success("Expense category updated successfully!");
        } else {
          await ExpenseCategoryServices.create(payload); // Hypothetical create method
          toast.success("Expense category created successfully!");
        }
        onSuccess();
        formik.resetForm();
      } catch (error) {
        toast.error(error.response?.data || "Failed to save expense category");
        console.error("Error saving expense category:", error);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={handleCancel}>
        {isEdit ? "Edit Expense Category" : "Create Expense Category"}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="title">Title</Label>
              <Input
                type="text"
                id="title"
                name="title"
                placeholder="Enter Title"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
                invalid={formik.touched.title && formik.errors.title}
              />
              {formik.touched.title && formik.errors.title && (
                <FormFeedback>{formik.errors.title}</FormFeedback>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mb-3">
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                id="description"
                name="description"
                placeholder="Enter Description"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                invalid={formik.touched.description && formik.errors.description}
              />
              {formik.touched.description && formik.errors.description && (
                <FormFeedback>{formik.errors.description}</FormFeedback>
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="success" disabled={formik.isSubmitting}>
            {isEdit ? "Update" : "Save"}
          </Button>
          <Button color="danger" onClick={handleCancel} type="button">
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ExpenseCategoryAddEditModal;